import { j as o } from "../../../jsx-runtime.BREq8dyb.js";
import { styled as a, Chip as s } from "@mui/joy";
import { memo as l, createElement as m, isValidElement as n } from "react";
const d = a(s)(({
  theme: {
    radius: t,
    palette: e
  },
  color: r
}) => ({
  // If selectable option of DqCard is used, apply styles depending on checked/unchecked state
  // not depending on whether component is controllable or not
  "&:has(+ .Mui-checked)": {
    background: r === "neutral" ? e.primary[500] : "",
    color: "initial"
  },
  borderRadius: t.xs,
  left: 0,
  margin: "auto",
  position: "absolute",
  right: 0,
  top: "-10px",
  zIndex: 3
})), p = l(({
  label: t,
  color: e,
  selectable: r,
  variant: i
}) => /* @__PURE__ */ o.jsx(d, { color: !r && i === "outlined" && e === "neutral" ? "primary" : e, size: "sm", variant: "solid", children: typeof t == "string" || n(t) ? t : m(t) }));
p.displayName = "DqCardLabel";
export {
  p as default
};
//# sourceMappingURL=DqCardLabel.js.map
